import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../../contexts/LocaleContext';
import { formatHardwarePrice } from '../../../../lib/hardwareFirst';
import { centsToDollars } from '../../../../lib/util';
import styles from './ShippingOptionsList.module.scss';

interface IShippingOptionsItemProps {
  name: string;
  description?: string;
  priceInCents?: number;
  disabled?: boolean;
  /** checkout v2 prices read like the cart's: $15, not $15.00 */
  compact?: boolean;
}

export default function ShippingOptionsItem({
  name,
  description,
  priceInCents,
  disabled,
  compact = false,
}: IShippingOptionsItemProps) {
  const { t } = useTranslation();
  const locale = useLocale();
  const price = !priceInCents
    ? t('free')
    : compact
      ? formatHardwarePrice(priceInCents, locale)
      : `$${centsToDollars(priceInCents)}`;
  return (
    <div
      className={classNames(styles.shippingOptionsItem, {
        [styles.disabled]: disabled,
      })}
    >
      <div className={styles.shippingMethod}>
        <div>{name}</div>
        {description && <div className={styles.shippingDescription}>{description}</div>}
      </div>
      <div className={styles.price}>{price}</div>
    </div>
  );
}
